export enum ApiStatus {
    FETCHING = 'fetching',
    FETCHED = 'fetched',
    POSTING = 'posting',
    ERROR = 'error'
}